module.exports = __webpack_public_path__ + "img/IDP-refugee-camp.4082378e.svg";